import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AnimatedCounter = ({ end, suffix, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;
    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [started, end, duration]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}{suffix}
    </span>
  );
};

const StatsSection = () => {
  const [stats, setStats] = useState({ students: 500000, courses: 10, years: 40, pillars: 4 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/stats`);
        setStats(res.data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      }
    };
    fetchStats();
  }, []);

  const statsArr = [
    { value: stats.students, suffix: '+', label: 'STUDENTS WORLDWIDE' },
    { value: stats.courses, suffix: '', label: 'PREMIUM COURSES' },
    { value: stats.years, suffix: '+', label: 'YEARS EXPERIENCE' },
    { value: stats.pillars, suffix: '', label: 'SPIRITUAL PILLARS' },
  ];

  return (
    <section style={{
      background: 'linear-gradient(180deg, #1a0e2e 0%, #0f0a1e 100%)',
      padding: '60px 20px',
      borderTop: '1px solid rgba(139, 92, 246, 0.15)',
      borderBottom: '1px solid rgba(139, 92, 246, 0.15)',
    }}>
      <div className="grid-stats" style={{
        maxWidth: '1100px',
        margin: '0 auto',
      }}>
        {statsArr.map((stat, index) => (
          <div key={index} style={{ padding: '20px' }}>
            <div style={{
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: 800,
              fontFamily: "'Playfair Display', serif",
              color: '#00d4ff',
              marginBottom: '8px',
            }}>
              <AnimatedCounter end={stat.value} suffix={stat.suffix} />
            </div>
            <p style={{
              fontSize: '12px',
              letterSpacing: '3px',
              color: '#8885a0',
              textTransform: 'uppercase',
              fontWeight: 500,
            }}>
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
